/**
 * @description 全局Model personalModel 挂载到 redux 上
 */
import createModel, { Tction } from '@tkit/model';
import {
  APIS,
  ParamsBodyuserFollowUsingPost,
  ParamsBodyuserEditUsingPost,
  ParamsuserInformationUsingGet,
  ParamsuserArticleNewUsingGet,
  ParamsuserThumpUpUsingGet,
  ParamsuserCommentUsingGet,
  ParamsuserQuestionUsingGet,
  ParamsgroupsJoinsUsingGet,
  ParamsquestionQuestionIdUsingDelete,
  ParamsanswerAnswerIdUsingDelete,
  ParamsquestionQuestionIdCollectUsingPost,
  ParamsBodyuserPressUsingPost,
  PointInfo,
  ParamsgroupsGroupIdJoinUsingPost,
  ParamsuserMyCollectionUsingGet,
  ParamsuserVoteUsingGet,
  ParamsvoteFollowVoteQuestionIdUsingPost
} from '@src/services';
import { message } from 'antd';
import { TkitUtils as Utils } from '@tkit/types';

import * as models from '@services/model/models';
import { AjaxCancelCode } from '@tkit/ajax';
export interface State {
  userInfoModel: models.UserInfo;
  newArticleListModel: models.PageableResultSingleArticleInfo;
  supArticleListModel: models.PageableResultSingleArticleInfo;
  commentArticleListModel: models.PageableResultUserCommentInfo;
  askListModel: models.PageableResultQuestionSimpleInfo;
  answerListModel: models.PageableResultAnswerSimpleInfo;
  groupListModel: models.PageableResultGroupVO;
  userLoading: boolean;
  collectModel: models.PageableResultSingleArticleInfo;
  userPointInfo: PointInfo;
  voteListModel: models.PageableResultVoteQuestionSimplePO;
}

export const personalModelState: State = {
  userInfoModel: {},
  newArticleListModel: {},
  supArticleListModel: {},
  commentArticleListModel: {},
  askListModel: {},
  answerListModel: {},
  groupListModel: {},
  userLoading: true,
  collectModel: {},
  userPointInfo: {},
  voteListModel: {}
};
const model = createModel({
  state: personalModelState,
  namespace: 'personalModel',
  reducers: {
    // 用户信息
    setUserInfo: (state, action: Tction<{ userInfoModel: models.UserInfo }>) => {
      return {
        ...state,
        userInfoModel: action.payload.userInfoModel
      };
    },
    // 更新用户信息简介
    updateUserInfo: (state, action: Tction<{ profile: string }>) => {
      const userInfoModel = {
        ...state.userInfoModel,
        profile: action.payload.profile
      };
      return {
        ...state,
        userInfoModel
      };
    },
    // 获取最新文章
    setNewArticleList: (
      state,
      action: Tction<{ newArticleListModel: models.PageableResultSingleArticleInfo; type?: string }>
    ) => {
      return {
        ...state,
        newArticleListModel: action.payload.newArticleListModel
      };
    },
    /**
     * @description 获取用户投票列表
     */
    setVoteList: (
      state,
      action: Tction<{ voteListModel: models.PageableResultVoteQuestionSimplePO }>
    ) => {
      return {
        ...state,
        voteListModel: action.payload.voteListModel
      };
    },
    /**
     * @description 更新用户投票关注
     */
    updateVoteFollow: (state, action: Tction<{ type: boolean; voteId: number }>) => {
      const { type, voteId } = action.payload;
      return {
        ...state,
        voteListModel: {
          ...state.voteListModel,
          list:
            state.voteListModel.list &&
            state.voteListModel.list.map((item: models.VoteQuestionSimplePO) => {
              if (item.voteQuestionId === voteId) {
                return {
                  ...item,
                  concerned: type
                };
              }
              return item;
            })
        }
      };
    },
    /**
     * @description 删除最新文章
     */
    deleteNewArt: (state, action: Tction<string>) => {
      const {
        newArticleListModel: oldListModel,
        newArticleListModel: { list = [] }
      } = state;
      const newArticleListModel = { ...oldListModel };

      newArticleListModel.list = list.filter(item => item.businessId !== action.payload);

      return {
        ...state,
        newArticleListModel
      };
    },
    // 获取已赞文章
    setSupArticleList: (
      state,
      action: Tction<{ supArticleListModel: models.PageableResultSingleArticleInfo }>
    ) => {
      return {
        ...state,
        supArticleListModel: action.payload.supArticleListModel
      };
    },
    // 获取已评论文章
    setCommentArticleList: (
      state,
      action: Tction<{
        commentArticleListModel: models.PageableResultUserCommentInfo;
      }>
    ) => {
      return {
        ...state,
        commentArticleListModel: action.payload.commentArticleListModel
      };
    },
    // 获取提问
    setAskList: (
      state,
      action: Tction<{
        askListModel: models.PageableResultQuestionSimpleInfo;
      }>
    ) => {
      return {
        ...state,
        askListModel: action.payload.askListModel
      };
    },
    /**
     * @description 删除已发布问题
     */
    deleteAsk: (state, action: Tction<number>) => {
      const {
        askListModel: oldListModel,
        askListModel: { list = [] }
      } = state;
      const askListModel = { ...oldListModel };

      askListModel.list = list.filter(item => item.questionId !== action.payload);

      return {
        ...state,
        askListModel
      };
    },
    // 获取回答
    setAnswerList: (
      state,
      action: Tction<{
        answerListModel: models.PageableResultAnswerSimpleInfo;
      }>
    ) => {
      return {
        ...state,
        answerListModel: action.payload.answerListModel
      };
    },
    /**
     * @description 删除已发布回答
     */
    deleteAnswer: (state, action: Tction<number>) => {
      const {
        answerListModel: oldListModel,
        answerListModel: { list = [] }
      } = state;
      const answerListModel = { ...oldListModel };

      answerListModel.list = list.filter(item => item.answerId !== action.payload);

      return {
        ...state,
        answerListModel
      };
    },
    // 重置页面数据
    setReset: state => {
      return {
        ...state,
        newArticleListModel: {},
        supArticleListModel: {},
        commentArticleListModel: {},
        askListModel: {},
        answerListModel: {}
      };
    },
    // 更新loading状态
    updateLoading: (state, action: Tction<boolean>) => {
      return {
        ...state,
        userLoading: action.payload
      };
    },
    // 更新问题|回答状态
    updateAskStatus: (state, action: Tction<{ questionIdVal: number; key: string; val: any }>) => {
      const { questionIdVal, key, val } = action.payload;
      const { askListModel } = state;
      const { list } = askListModel;
      if (list) {
        list.map((item: models.QuestionSimpleInfo) => {
          const { questionId } = item;
          if (questionId === questionIdVal) {
            item[key] = val;
          }
        });
      }
      return {
        ...state,
        askListModel
      };
    },
    // 更新问题|回答状态
    updateAnswerStatus: (state, action: Tction<{ answerIdVal: number; key: string; val: any }>) => {
      const { answerIdVal, key, val } = action.payload;
      const { answerListModel } = state;
      const { list } = answerListModel;
      if (list) {
        list.map((item: models.AnswerSimpleInfo) => {
          const { answerId } = item;
          if (answerId === answerIdVal) {
            item[key] = val;
          }
        });
      }
      return {
        ...state,
        answerListModel
      };
    },
    // 设置收藏列表
    setCollectionList: (state, action: Tction<models.PageableResultSingleArticleInfo>) => {
      return {
        ...state,
        collectModel: action.payload
      };
    },
    // 更新收藏列表收藏
    setCancelCollection: (state, action: Tction<number>) => {
      const {
        collectModel: oldModel,
        collectModel: { list = [] }
      } = state;
      const collectModel = {
        ...oldModel,
        list: list.filter(item => item.id !== action.payload)
      };

      return {
        ...state,
        collectModel
      };
    },
    /** 更新催更状态 */
    updateUserInfoCanPress: state => {
      return {
        ...state,
        userInfoModel: {
          ...state.userInfoModel,
          canPress: false
        }
      };
    },
    /** 设置圈子列表 */
    setGroups: (state, action: Tction<models.PageableResultGroupVO>) => {
      return {
        ...state,
        groupListModel: action.payload
      };
    },
    /** 退出圈子 */
    QuitGroups: (state, action: Tction<number>) => {
      const {
        groupListModel,
        groupListModel: { list = [] }
      } = state;

      return {
        ...state,
        groupListModel: {
          ...groupListModel,
          list: list.filter(item => item.id !== action.payload)
        }
      };
    },
    /** 设置用户积分信息 */
    setUserScore: (state, action: Tction<PointInfo>) => {
      return {
        ...state,
        userPointInfo: action.payload
      };
    }
  },
  effects: {
    // 关注/取关用户
    *userFollow(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsBodyuserFollowUsingPost;
        callBack: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const res = yield tCall(APIS.UserApi.userFollowUsingPost, action.payload.params);
      action.payload.callBack(res);
    },
    // 修改个人信息
    *userEdit(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsBodyuserEditUsingPost;
        callBack: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const res = yield tCall(APIS.UserApi.userEditUsingPost, action.payload.params);
      const { code } = res;
      if (code === 0) {
        yield tPut(model.actions.updateUserInfo, { profile: action.payload.params.profile || '' });
      }
      action.payload.callBack(res);
    },
    // 用户信息
    *getUserInfo(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsuserInformationUsingGet;
        callBack: (result: models.UserInfo) => void;
      }>
    ): Iterator<{}, any, any> {
      const res = yield tCall(APIS.UserApi.userInformationUsingGet, action.payload.params);
      if (res.code === 0) {
        yield tPut(model.actions.setUserInfo, { userInfoModel: res.result || {} });
        action.payload.callBack(res.result);
      }
    },
    // 获取最新章
    *getNewArticleList(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsuserArticleNewUsingGet;
        needLoading?: boolean;
        callBack?: (num: number) => void;
      }>
    ): Iterator<{}, any, any> {
      const { needLoading = true } = action.payload;

      if (needLoading) {
        yield tPut(model.actions.updateLoading, true);
      }
      const res = yield tCall(APIS.UserApi.userArticleNewUsingGet, action.payload.params);
      if (needLoading) {
        yield tPut(model.actions.updateLoading, false);
      }

      const { code, result } = res;
      const { callBack } = action.payload;
      if (code === 0) {
        yield tPut(model.actions.setNewArticleList, { newArticleListModel: result });
        callBack && callBack(result.total);
      }
    },
    // 获取赞已赞文章
    *getSupArticleList(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsuserThumpUpUsingGet;
        callBack?: (num: number) => void;
      }>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.updateLoading, true);
      const res = yield tCall(APIS.UserApi.userThumpUpUsingGet, action.payload.params);
      yield tPut(model.actions.updateLoading, false);
      const { code, result } = res;
      const { callBack } = action.payload;
      if (code === 0) {
        yield tPut(model.actions.setSupArticleList, { supArticleListModel: result });
        callBack && callBack(result.total);
      }
    },
    // 获取已评论文章
    *getCommentArticleList(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsuserCommentUsingGet;
        callBack?: (num: number) => void;
      }>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.updateLoading, true);
      const res = yield tCall(APIS.UserApi.userCommentUsingGet, action.payload.params);
      yield tPut(model.actions.updateLoading, false);
      const { code, result } = res;
      const { callBack } = action.payload;
      if (code === 0) {
        yield tPut(model.actions.setCommentArticleList, { commentArticleListModel: result });
        callBack && callBack(result.total);
      }
    },
    // 获取提问
    *getAskList(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsuserQuestionUsingGet;
        needLoading?: boolean;
        callBack?: (num: number) => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callBack, needLoading = true } = action.payload;
      if (needLoading) {
        yield tPut(model.actions.updateLoading, true);
      }
      const res = yield tCall(APIS.UserApi.userQuestionUsingGet, params);
      if (needLoading) {
        yield tPut(model.actions.updateLoading, false);
      }
      const { code, result } = res;
      if (code === 0) {
        yield tPut(model.actions.setAskList, { askListModel: result });
        callBack && callBack(result.total);
      }
    },
    /**
     * @description 删除已发布问题
     */
    *removeAskAsync(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsquestionQuestionIdUsingDelete;
        pageNum: number;
        pageSize: number;
        targetUser: string;
        callBack: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { questionId } = action.payload.params;
      const { callBack, pageNum, pageSize, targetUser } = action.payload;
      const data: Utils.GetROA<typeof APIS.QuestionApi.questionQuestionIdUsingDelete> = yield tCall(
        APIS.QuestionApi.questionQuestionIdUsingDelete,
        action.payload.params
      );

      if (data.code === 0) {
        // yield tPut(model.actions.deleteAsk, questionId);
        yield tPut(model.actions.getAskList, {
          params: { pageNum, pageSize, targetUser },
          needLoading: false
        });
        callBack && callBack();
        message.success('删除成功');
      }
    },
    // 获取回答
    *getAnswerList(
      { tPut, tCall },
      action: Tction<{
        params: ParamsuserQuestionUsingGet;
        needLoading?: boolean;
        callBack?: (num: number) => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callBack, needLoading = true } = action.payload;
      if (needLoading) {
        yield tPut(model.actions.updateLoading, true);
      }
      const res = yield tCall(APIS.UserApi.userAnswerUsingGet, params);
      if (needLoading) {
        yield tPut(model.actions.updateLoading, false);
      }
      const { code, result } = res;
      if (code === 0) {
        yield tPut(model.actions.setAnswerList, { answerListModel: result });
        callBack && callBack(result.total);
      }
    },
    /**
     * @description 删除已发布回答
     */
    *removeAnswerAsync(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsanswerAnswerIdUsingDelete;
        pageNum: number;
        pageSize: number;
        targetUser: string;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { answerId } = action.payload.params;
      const { callBack, pageSize, pageNum, targetUser } = action.payload;
      const data: Utils.GetROA<typeof APIS.AnswerApi.answerAnswerIdUsingDelete> = yield tCall(
        APIS.AnswerApi.answerAnswerIdUsingDelete,
        action.payload.params
      );

      if (data.code === 0) {
        // yield tPut(model.actions.deleteAnswer, answerId);
        yield tPut(model.actions.getAnswerList, {
          params: { pageNum, pageSize, targetUser },
          needLoading: false
        });
        callBack && callBack();
        message.success('删除成功');
      }
    },
    /**
     * @description 催更
     * @param content 内容
     * @param username 用户
     */
    *remindUser(
      { tPut, tCall },
      action: Tction<{
        data: ParamsBodyuserPressUsingPost;
      }>
    ): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.UserApi.userPressUsingPost> = yield tCall(
        APIS.UserApi.userPressUsingPost,
        action.payload.data
      );
      if (res.code === 0) {
        tPut(model.actions.updateUserInfoCanPress);
        message.success('已经催更啦，请耐心等待更新吧！');
      } else {
        message.error(res.message);
      }
    },

    // 提问关注
    *doFollowHomeQuestion(
      { tPut, tCall },
      action: Tction<{
        params: ParamsquestionQuestionIdCollectUsingPost;
        callBack?: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const {
        params,
        callBack,
        params: { questionId, type }
      } = action.payload;
      const parmsObj = { questionIdVal: questionId, key: 'isFollowing', val: true };
      yield tPut(model.actions.updateAskStatus, parmsObj);
      const res = yield tCall(APIS.QuestionApi.questionQuestionIdCollectUsingPost, params);
      const { code } = res;
      if (code === 0) {
        yield tPut(model.actions.updateAskStatus, {
          questionIdVal: questionId,
          key: 'hasFollow',
          val: type
        });
      }
      parmsObj.val = false;
      yield tPut(model.actions.updateAskStatus, parmsObj);
      callBack && callBack(res);
    },
    // 回答赞同
    *doAgreeHomeAnswer(
      { tPut, tCall },
      action: Tction<{
        params: {
          answerId: number;
          type: number;
        };
        callBack?: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const {
        params,
        callBack,
        params: { answerId, type }
      } = action.payload;
      const parmsObj = { answerIdVal: answerId, key: 'isFollowing', val: true };
      yield tPut(model.actions.updateAnswerStatus, parmsObj);
      const res = yield tCall(APIS.AnswerApi.answerAnswerIdAgreeUsingPost, params);
      const { code, result } = res;
      if (code === 0) {
        // 更新状态
        yield tPut(model.actions.updateAnswerStatus, {
          answerIdVal: answerId,
          key: 'agreeStatus',
          val: type
        });
        // 更新赞同数量
        yield tPut(model.actions.updateAnswerStatus, {
          answerIdVal: answerId,
          key: 'agreeCount',
          val: result.agreeCount
        });
      }
      parmsObj.val = false;
      yield tPut(model.actions.updateAnswerStatus, parmsObj);
      callBack && callBack(res);
    },
    // 重置页面数据
    *reset({ namespace, put, tPut, tCall }): Iterator<{}, any, any> {
      yield tPut(model.actions.setReset);
    },
    /**
     * @description 删除文章
     */
    *removeArtAsync(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsuserArticleNewUsingGet;
        businessId: string;
        type: number;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callBack, businessId, type } = action.payload;
      const res: Utils.GetROA<typeof APIS.ArticleApi.articleNewBusinessIdUsingDelete> = yield tCall(
        APIS.ArticleApi.articleNewBusinessIdUsingDelete,
        { businessId, type }
      );

      if (res.code === 0) {
        const { pageSize, pageNum, targetUser, type } = params;
        // yield tPut(model.actions.deleteNewArt, businessId);
        yield tPut(model.actions.getNewArticleList, {
          params: { pageNum, pageSize, targetUser, type },
          needLoading: false
        });
        callBack && callBack();
        message.success('删除成功');
      }
    },
    /**
     * @description 获取收藏列表
     */
    *getCollectListAsync(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsuserMyCollectionUsingGet;
        needLoading?: boolean;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, needLoading } = action.payload;
      if (needLoading) {
        yield tPut(model.actions.updateLoading, true);
      }
      const res: Utils.GetROA<typeof APIS.UserApi.userMyCollectionUsingGet> = yield tCall(
        APIS.UserApi.userMyCollectionUsingGet,
        params
      );
      if (res.code === 0 && res.result) {
        yield tPut(model.actions.setCollectionList, res.result);
      }
      if (needLoading) {
        yield tPut(model.actions.updateLoading, false);
      }
    },
    /**
     * @description 取消收藏
     */
    *cancelCollectAsync(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: { articleId: number };
        pageNum: number;
        pageSize: number;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callBack, pageNum, pageSize } = action.payload;
      const res: Utils.GetROA<typeof APIS.UserApi.userCollectionArticleIdCancelUsingPost> = yield tCall(
        APIS.UserApi.userCollectionArticleIdCancelUsingPost,
        params
      );

      if (res.code === 0) {
        yield tPut(model.actions.getCollectListAsync, {
          params: { pageSize, pageNum },
          needLoading: false
        });
        // yield tPut(model.actions.setCancelCollection, params.articleId);
        callBack && callBack();
        message.success('取消收藏成功');
      }
    },
    /**
     * @description 根据id加入或者退出圈子
     */
    *toggleJoinGroup(
      { tPut, tCall },
      action: Tction<{
        params: ParamsgroupsGroupIdJoinUsingPost;
        pageNum: number;
        pageSize: number;
        interview?: boolean;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.GroupApi.groupsGroupIdJoinUsingPost> = yield tCall(
        APIS.GroupApi.groupsGroupIdJoinUsingPost,
        action.payload.params
      );

      if (res.code === 0) {
        const { join } = action.payload.params;
        const { callBack, pageNum, pageSize } = action.payload;
        if (!join) {
          // yield tPut(model.actions.QuitGroups, groupId);
          yield tPut(model.actions.getGroupsAsync, {
            params: { pageNum, pageSize },
            needLoading: false
          });
          callBack && callBack();
        }
        message.success(join ? '已成功加入圈子' : '已退出圈子');
      } else {
        message.error(res.message);
      }
    },

    /**
     * @description 获取圈子
     */
    *getGroupsAsync(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsgroupsJoinsUsingGet;
        needLoading?: boolean;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callBack, needLoading = true } = action.payload;
      if (needLoading) {
        yield tPut(model.actions.updateLoading, true);
      }
      const res: Utils.GetROA<typeof APIS.GroupApi.groupsJoinsUsingGet> = yield tCall(
        APIS.GroupApi.groupsJoinsUsingGet,
        params
      );

      if (res.code === 0 && res.result) {
        yield tPut(model.actions.setGroups, res.result);
        callBack && callBack();
      }
      if (needLoading) {
        yield tPut(model.actions.updateLoading, false);
      }
    },
    /**
     * @description 获取用户等级信息
     */
    *getUserScoreAsync(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: { username: string };
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callBack } = action.payload;
      const res: Utils.GetROA<typeof APIS.PointApi.pointUsernameUsingGet> = yield tCall(
        APIS.PointApi.pointUsernameUsingGet,
        params
      );

      if (res.code === 0 && res.result) {
        yield tPut(model.actions.setUserScore, res.result);
        callBack && callBack();
      }
    },
    /**
     * @description 获取投票列表
     */
    *getVoteList(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsuserVoteUsingGet;
        needLoading?: boolean;
      }>
    ): Iterator<{}, any, any> {
      const { needLoading = true } = action.payload;

      if (needLoading) {
        yield tPut(model.actions.updateLoading, true);
      }
      const res = yield tCall(APIS.UserApi.userVoteUsingGet, action.payload.params);
      if (needLoading) {
        yield tPut(model.actions.updateLoading, false);
      }

      const { code, result } = res;
      if (code === 0) {
        yield tPut(model.actions.setVoteList, { voteListModel: result });
      }
    },

    /**
     * @description 投票删除
     */
    *voteRemove(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsuserVoteUsingGet;
        voteQuestionId: number;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, voteQuestionId, callBack } = action.payload;
      const res: Utils.GetROA<typeof APIS.VoteApi.voteDeleteUsingGet> = yield tCall(
        APIS.VoteApi.voteDeleteUsingGet,
        {
          voteQuestionId
        }
      );

      if (res.code === 0) {
        const { pageNum, pageSize, targetUser } = params;
        // yield tPut(model.actions.deleteNewArt, businessId);
        yield tPut(model.actions.getVoteList, {
          params: { pageNum, pageSize, targetUser },
          needLoading: false
        });
        callBack && callBack();
        message.success('删除成功');
      }
    },

    /**
     * @description 投票关注切换
     */
    *toggleVoteFollow(
      { tPut, tCall },
      action: Tction<{
        params: ParamsvoteFollowVoteQuestionIdUsingPost;
      }>
    ): Iterator<{}, any, any> {
      const { params } = action.payload;
      const res: Utils.GetROA<typeof APIS.VoteApi.voteFollowVoteQuestionIdUsingPost> = yield tCall(
        APIS.VoteApi.voteFollowVoteQuestionIdUsingPost,
        params
      );
      if (res.code === 0) {
        yield tPut(model.actions.updateVoteFollow, {
          voteId: params.voteQuestionId,
          type: params.type
        });
        message.success(params.type ? '已关注' : '已取消关注');
      } else {
        message.error(res.message);
      }
    }
  }
});

export default model;
